import { flatten } from "flat";

import Tokens from "./semantic";
import { RadiusToken } from "./types";

export const RADIUS_TOKENS = Object.keys(flatten(Tokens)) as RadiusToken[];

export const DEFAULT_RADIUS_TOKEN_SET_PREFIX = "Radius." as const;
